export default __webpack_public_path__ + "static/media/training-illustration6.e9a75d94.svg";